import React, { useContext, useState } from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import { register } from '../../i18n';

const t = register('GlobalQuestionLabels');

const ShowPreviousResponseButton = observer(({ lessonElementId, onShowPreviousResponse, isDisabled }) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    if (isDisabled || isLoading) return;
    
    setIsLoading(true);
    try {
      await onShowPreviousResponse();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <button
      className="show-previous-response-button"
      onClick={handleClick}
      disabled={isDisabled || isLoading}
      type="button"
      aria-label={t('showPreviousResponse')}
    >
      {isLoading ? t('loading') : t('showPreviousResponse')}
    </button>
  );
});

export default ShowPreviousResponseButton;
